module.exports = __webpack_public_path__ + "ad7b8392ccfec8f64d50df971a52cce6.pdf";